import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, hasError = false, ...inputProps },
  forwardedRef
) {
  return (
    <input
      ref={forwardedRef}
      className={cn(
        'w-full px-4 py-2.5 bg-zoooffwhite border rounded-xl text-zooindigo transition-all placeholder:text-zoomuted focus:outline-none focus:border-zooprimary focus:ring-2 focus:ring-zooprimary/40 disabled:bg-zoodisabledbg disabled:text-zoodisabledtext',
        hasError ? 'border-zooerrorborder ring-1 ring-zooerrorborder' : 'border-zooborder',
        className
      )}
      {...inputProps}
    />
  );
});
